import FullPostView from './FullPostView';

export default FullPostView;
